module.exports = __webpack_public_path__ + "static/media/ondas.ca17fa9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/iconos/ondas.png
// module id = 94
// module chunks = 0